import classNames from 'classnames';

const getErrorClass = (classes, field) =>
  classNames(classes, {
    'has-error': field.meta.touched && field.meta.error
  });

export default getErrorClass;
